import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import StylistCard from '../../components/StylistCard';

function TabletStylistLayout({ stylists }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = stylists.length;
  const slidesToShow = 2;

  const nextSlide = () => {
    setCurrentSlide((prev) => 
      prev === totalSlides - slidesToShow ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => 
      prev === 0 ? totalSlides - slidesToShow : prev - 1
    );
  };

  return (
    <div className="relative px-16">
      <button
        onClick={prevSlide}
        className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-black opacity-40 p-3 rounded-full z-10 text-black hover:text-white transition-all duration-300 backdrop-blur-sm"
      >
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-black opacity-40 p-3 rounded-full z-10 text-black hover:text-white transition-all duration-300 backdrop-blur-sm"
      >
        <ChevronRight className="w-6 h-6" />
      </button>

      <div className="overflow-hidden">
        <div 
          className="flex transition-transform duration-500 ease-out gap-6"
          style={{
            transform: `translateX(-${currentSlide * (100 / slidesToShow)}%)`
          }}
        >
          {stylists.map((stylist, index) => (
            <div 
              key={index} 
              className="relative flex-none w-1/2 group"
            >
              <div className="relative overflow-hidden rounded-lg">
                <StylistCard key={stylist.name} {...stylist} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center gap-3 mt-8">
        {Array.from({ length: totalSlides - (slidesToShow - 1) }).map((_, index) => (
          <button
            key={index}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              index === currentSlide 
                ? 'bg-white w-6' 
                : 'bg-gray-600 hover:bg-gray-400'
            }`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default TabletStylistLayout;